export function formatSize(size: number | string) {
  if (typeof size === 'number') {
    return `${size}px`
  }

  return size
}

export function getDirectionTransitionConfig({
  direction,
  size,
}: {
  direction: 'left' | 'right'
  size: number | string
}) {
  if (direction === 'left') {
    return {
      from: {
        width: formatSize(size),
        height: '100vh',
        transform: 'translateX(-100%)',
        opacity: 0.9,
      },
      enter: {
        width: formatSize(size),
        height: '100vh',
        transform: 'translateX(0%)',
        opacity: 1,
      },
      leave: {
        width: formatSize(size),
        height: '100vh',
        transform: 'translateX(-100%)',
        opacity: 0.9,
      },
    }
  }

  if (direction === 'right') {
    return {
      from: {
        width: formatSize(size),
        height: '100vh',
        transform: 'translateX(100%)',
        opacity: 0.9,
      },
      enter: {
        width: formatSize(size),
        height: '100vh',
        transform: 'translateX(0%)',
        opacity: 1,
      },
      leave: {
        width: formatSize(size),
        height: '100vh',
        transform: 'translateX(100%)',
        opacity: 0.9,
      },
    }
  }

  return {}
}
